import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SearchForm } from "../../../Model/Dto/SearchForm";
import { SearchFormsService } from "../../../Services/SearchForms/searchforms.service";
import { LoginService } from "../../../Services/login.service";

@Component({
    selector: "searchFormOptions",
    templateUrl: "searchFormOptions.component.html",
    styleUrls: [],
    standalone: false
})
export class SearchFormOptionsComponent implements OnInit {

  @Output() onEditSearchForm = new EventEmitter<void>();
  @Output() onExecuteSearchForm = new EventEmitter<SearchForm>();

  allSearchForms: SearchForm[] = [];
  selectedSearchForm: SearchForm;

  constructor(
    public translate: TranslateService,
    private searchFormsService: SearchFormsService,
    private loginService: LoginService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.loadSearchForms();
  }

  async loadSearchForms() {
    const customerId = this.loginService.currentUser.customerId;
    const userId = this.loginService.currentUser.id;
    this.allSearchForms = await this.searchFormsService.getAllbyUserId(customerId, userId) ?? [];
  }

  executeSearchForm() {
    if (!this.selectedSearchForm) return;
    this.onExecuteSearchForm.emit(this.selectedSearchForm);
  }

  editSearchForm() {
    this.onEditSearchForm.emit();
  }

  async saveSelectedSearchForm() {
    if (!this.selectedSearchForm) return;
    const customerId = this.loginService.currentUser.customerId;
    await this.searchFormsService.updateOrCreateSearchForm(this.selectedSearchForm, customerId);
  }
}
